import type { GeoJsonFeatureCollection } from '../geojsonBase';
import type { ArcGisClassBreaksRendererJson } from '../map/buildDefectRulesRenderer';
import type { DefectGeometryKind } from '../map/defectGeometry';
import { toArcGisGeometryType } from '../map/defectGeometry';
import { buildCrackmapRenderer } from './buildCrackmapRenderer';

export const CRACKMAP_LAYER_SPATIAL_REFERENCE = { wkid: 4326 } as const;

export interface CrackmapGeoJsonLayerConfig {
  readonly blobUrl: string;
  readonly layerProperties: {
    readonly id: string;
    readonly url: string;
    readonly title: string;
    readonly geometryType: ReturnType<typeof toArcGisGeometryType>;
    readonly popupEnabled: false;
    readonly spatialReference: typeof CRACKMAP_LAYER_SPATIAL_REFERENCE;
    readonly renderer: ArcGisClassBreaksRendererJson;
    readonly outFields: readonly ['*'];
    readonly listMode: 'hide';
  };
}

export function createCrackmapGeoJsonLayerConfig(
  mapLayerId: string,
  title: string,
  collection: GeoJsonFeatureCollection,
  lineWidth?: number,
  lineStyle?: string,
  options?: {
    readonly geometryKind?: DefectGeometryKind;
    readonly renderer?: ArcGisClassBreaksRendererJson;
  },
): CrackmapGeoJsonLayerConfig {
  const blob = new Blob([JSON.stringify(collection)], { type: 'application/json' });
  const blobUrl = URL.createObjectURL(blob);
  const geometryKind = options?.geometryKind ?? 'polyline';

  return {
    blobUrl,
    layerProperties: {
      id: mapLayerId,
      url: blobUrl,
      title,
      geometryType: toArcGisGeometryType(geometryKind),
      popupEnabled: false,
      spatialReference: CRACKMAP_LAYER_SPATIAL_REFERENCE,
      renderer:
        options?.renderer ?? buildCrackmapRenderer(lineWidth, lineStyle),
      outFields: ['*'],
      listMode: 'hide',
    },
  };
}
